export default {
  computed: {
    customDomain() {
      return this.$domainStore.state?.roomBaseServer?.watchInitData?.custom_domain;
    }
  },
  watch: {
    customDomain: {
      handler(newVal) {
        if (newVal) {
          window._customDomain = newVal;
        }
      },
      immediate: true
    }
  }
};
